<template>
  <div v-html="html"></div>
</template>

<script>
import api from '@/services/api'

export default {
  props: {
    extractedTextUrl: {
      type: String,
      required: true,
    },
    pageNum: {
      type: Number,
      required: true,
    },
    searchTerms: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      extractedText: null,
      highlightedText: null,
    }
  },

  computed: {
    html() {
      return (
        (this.searchTerms && this.highlightedText) ||
        this.extractedText ||
        this.highlightedText ||
        ''
      )
    },
  },

  watch: {
    searchTerms() {
      this.fetch()
    },
    html() {
      this.$nextTick(() => {
        // HTML fragment returned by Tizra includes ids on everything.
        // This might be something we need to handle for Readspeaker
        // eventually, but we don't support that yet, so just kill them.
        Array.from(this.$el.querySelectorAll('[id]')).forEach(el => {
          el.removeAttribute('id')
        })
      })
    },
  },

  mounted() {
    this.fetch()
  },

  methods: {
    fetch() {
      if (this.searchTerms) {
        this.fetchHighlights().catch(() => {
          if (this.extractedText) {
            this.highlightedText = null
          } else {
            this.fetchExtracted().then(() => {
              if (this.extractedText) {
                this.highlightedText = null
              }
            })
          }
        })
      } else {
        this.fetchExtracted()
      }
    },

    fetchHighlights() {
      return api
        .getHighlights(this.pubInfo.tizraId, this.pageNum, this.searchTerms)
        .then(html => {
          this.highlightedText = html
        })
        .catch(e => {
          this.$pub('error', e)
          throw e // for this.fetch() to catch
        })
    },

    fetchExtracted() {
      return api
        .getExtractedText(this.extractedTextUrl)
        .then(html => {
          this.extractedText = html
        })
        .catch(e => {
          this.$pub('error', e)
        })
    },
  },

  inject: ['pubInfo'],
}
</script>

<style>
/* These are the functional styles required by this component. There are
 * also presentational styles, search for t-highlight in the SCSS theme.
 */
.t-extracted-page .t-word {
  display: block;
  position: absolute;
  color: transparent;
  white-space: nowrap;
  overflow: hidden;
}

.t-extracted-page .t-word .t-highlight {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
